<template>
  <Modal 
    :id="'cmp-licence-export-licence'" 
    @cancelled="onCancel"
  >
    <template slot="header">{{$t('Export')}} {{  $dft.snakeCaseToWords('licence')}} </template>
    <template slot="body">
      <div class="form-group">
          <TextField
            :id="'licence_name'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="payloadObject.licence_name"
            isModel
            :placeholder="$t('licence_name')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'licence_account'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="payloadObject.licence_account"
            isModel
            :placeholder="$t('licence_account')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'repertoire'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="payloadObject.repertoire"
            isModel
            :placeholder="$dft.capHead($t('repertoire'))"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'licensor'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="payloadObject.licensor"
            isModel
            :placeholder="$t('licensor')"
            @valuechanged="onTextFieldValueChange"
          />

          <Dropdown
            :id="'licence_account_status_id'"
            class="m2"
            :options="licenceAccountStatusTV || []"
            :selected="licenceAccountStatusTV.find((t) => t.value == payloadObject.licence_account_status_id)"
            :placeholder="`${$t('licence_account')} ${$t('status')}`"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('licence_account_status_id', e)"
            :listHeight="250"
          />
          <Dropdown
            :id="'licence_status_id'"
            class="m2"
            :options="licenceTypesTV || []"
            :selected="licenceTypesTV.find((t) => t.value == payloadObject.licence_status_id)"
            :placeholder="`${$t('licence_type')}`"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('licence_status_id', e)"
            :listHeight="250"
          />

          <Dropdown
            :id="'royalty_account_id'"
            class="m2"
            :options="royaltyAccountTV || []"
            :selected="royaltyAccountTV.find((t) => t.value == payloadObject.royalty_account_id)"
            :placeholder="`${$t('royalty_account')}`"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('royalty_account_id', e)"
            :listHeight="250"
          />
          <div class="date-control ut-flex">
            <TextField
              type="date"
              :id="'licence_start1'"
              class="m1"
              :placeholder="`${$t('licence')} ${$t('start')}`"
              :value="payloadObject.licence_start1"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
            <TextField
              type="date"
              :id="'licence_end1'"
              class="m1"
              :placeholder="`${$t('licence')} ${$t('start')}`"
              :value="payloadObject.licence_end1"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
          </div>
          <div class="date-control ut-flex">
            <TextField
              type="date"
              :id="'licence_start2'"
              class="m1"
              :placeholder="`${$t('licence')} ${$t('end')}`"
              :value="payloadObject.licence_start2"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
            <TextField
              type="date"
              :id="'licence_end2'"
              class="m1"
              :placeholder="`${$t('licence')} ${$t('end')}`"
              :value="payloadObject.licence_end2"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
          </div>
          <div class="date-control ut-flex">
            <TextField
              type="date"
              :id="'last_statement_start'"
              class="m1"
              :placeholder="`${$t('last_stmt')} ${$t('start')}`"
              :value="payloadObject.last_statement_start"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
            <TextField
              type="date"
              :id="'last_statement_end'"
              class="m1"
              :placeholder="`${$t('last_stmt')} ${$t('end')}`"
              :value="payloadObject.last_statement_end"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
          </div>

          <Dropdown
            :id="'territory_id'"
            class="m2"
            :options="territoryTV || []"
            :selected="territoryTV.find((t) => t.value == payloadObject.territory_id)"
            :placeholder="`${$t('territory')}`"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('territory_id', e)"
            :listHeight="250"
          />



         

          <!-- <Dropdown
            :id="'last_stmt'"
            class="m2"
            :options="payloadObject.lastStmtTV"
            :selected="
              payloadObject.lastStmtTV.find((x) => x.value == last_stmt)
            "
            :placeholder="$t('last_stmt')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('last_stmt', e)"
          ></Dropdown> -->
        </div>
    </template>
    <template slot="options">
      
      <button 
        class="dt-button s6" 
        @click.stop="onCancel"
      >Cancel</button>
      <button
        class="dt-button v1 with-ico"
       
        @click.stop="onExport"
      >
        {{$t('ok')}}
      </button>
    </template>
  </Modal>
</template>

<script>

import Modal from '@dtplugins/modal/modal';
import { licenceAccountsService } from '../../services/licence-accounts.service';
import DTCheckbox from "../../../../plugins/checkbox/checkbox";
import {
  createTV,
  tv,
} from "../../../../models/text-value.model";
import { licenceService } from '../../services/licence.service';
import FileDownload from "js-file-download";
import { format } from "date-fns";
import { licenceGetters } from '../../store/licence/getters';
import { LicenceStoreNamespace as storeNS } from "../../store";
import {
  mapGetterObject
} from "../../../../store/global";
export default {
  components: {
    Modal,
    DTCheckbox,

  },
  props: {
    
  },
  data: function() {
    return {
     textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        // showValidationIcons: true,
        // immediateValidation: true,
        //format(new Date().setDate(new Date().getDate() + 7), "YYYY-MM-DD")
      },
      payloadObject:{
          territory_id:undefined,
          royalty_account_id:undefined,
          licence_status_id:undefined,
          licence_account_status_id:undefined,
          licence_start1:'',
          licence_end1:'',
          licence_start2:'',
          licence_end2:'',
          last_statement_start:'',
          last_statement_end:'',
      },
      validationResult: {},
    };
  },
  mounted:async function() {
    // const resData= await licenceService.exportLicenceLinesModal();
    // console.log("resData",resData);
    // this.territoryList=resData.data.territories;
    // this.trackList=resData.data.tracks

  },
  computed: {
    ...mapGetterObject(storeNS ,licenceGetters),
    

    licenceAccountStatusTV:function(){
      console.log("GETTERS",this?.licencesList)
      return createTV(this?.licencesList?.licence_account_statuses,"label_status_name","label_status_id")||[];
    },
    
    licenceTypesTV:function(){
      return createTV(this?.licencesList?.licence_statuses,"label_status_name","label_status_id")
    },

    royaltyAccountTV:function(){
      return createTV(this?.licencesList?.royalty_accounts,"royalty_account_name","royalty_account_id")
    },
    territoryTV:function(){
      return createTV(this?.licencesList?.territories,"territory_name","territory_id")
    },
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    },
  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onDropdownChange: function (name, value) {      // <-- Normal Form Handling Methods
            this.payloadObject[name]=value.value
            console.log(name,value,this[name])

    },
    onTextFieldValueChange:function(key, value){
      console.log("NAME",key,value)
      this.payloadObject[key]=value
    },
    onDateChange: function (name, value) {
      //this[name] = value;
      this.payloadObject[name]=value
    },
    onCancel: function() {
      this.$emit("cancelled", true);
    },
    onExport: function() {
      const fileBlob =licenceService.licenceExportLicences({...this.payloadObject}).then(res=>{
        console.log(res,"::::::::BLOB")
        FileDownload(res.data,'licence.xlsx');
      });

      this.onCancel();

    }
    //MARK: Methods
  }
};


</script>

<style lang="scss">
.cmp-licence-export-licence {
  .date-control {
    .dt-input-box--container {
      flex: 1;
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
}
</style>